import { Link } from 'react-router-dom';
import { TriangleAlert } from 'lucide-react';
import { Callout, formatDatum, formatEuro } from '@elbklar/ui';

interface Props {
  /** Stichtag des Kontostands. */
  stichtag: string | null;
  /** Was zwischen Stichtag und heute eingeplant war. */
  fortgeschrieben: string;
}

/**
 * Der Hinweis, der lange gefehlt hat.
 *
 * Die Projektion ankert am Kontostand-Snapshot. Liegt dessen Stichtag zurueck,
 * rechnet sie die Zeit bis heute mit der Planung fort — besser, als die Posten
 * dazwischen fallen zu lassen. Genau das tat sie bis September 2026 und verlor
 * dabei eine Darlehensauszahlung ueber 190.000 EUR, sobald deren Faelligkeit
 * einen Tag zurueck lag.
 *
 * Fortgeschrieben bleibt aber gerechnet, nicht von der Bank bestaetigt. Wer
 * die Kurve liest, muss wissen, welcher Teil davon nur angenommen ist.
 *
 * Still bleibt der Hinweis, wenn es nichts zu sagen gibt: aktueller Stichtag,
 * keine Bewegung in der Luecke, oder gar kein Kontostand — fuer den Fall gibt
 * es einen eigenen, deutlicheren Block auf der Uebersicht.
 */
export function KontostandHinweis({ stichtag, fortgeschrieben }: Props) {
  const betrag = Number(fortgeschrieben);
  if (!stichtag || !betrag) return null;

  return (
    <Callout tone="warning" icon={TriangleAlert} title={`Kontostand vom ${formatDatum(stichtag)}`} boxed>
      <p>
        Seither sind <strong className="font-semibold tabular">{formatEuro(betrag, { cent: true })}</strong> eingeplant,
        die in der Kurve stecken, aber von der Bank nicht bestätigt sind.
      </p>
      <Link
        to="/einstellungen?reiter=kontostand"
        className="inline-flex min-h-6 items-center font-medium text-foreground underline underline-offset-2 touch:min-h-11"
      >
        Kontostand nachtragen
      </Link>
    </Callout>
  );
}
